import styled from 'styled-components';

export const SliderWrapper = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 99;
  padding: 10px 30px;
  box-sizing: border-box;
`;
